<!--
 <Object :objectCode="offer.rentalObjectCode">
 </Object>
-->
<template>
  <div class="object" :class="[typeCaption, subCaption]" :key="unique">
    <Loader v-if="showLoader" />
    <router-link
      class="object-btn"
      :to="{ name: 'Vacancy', params: { id: unique }, query: $route.query }"
      @click="mtm()"
    >
      <div class="object-list-item">
        <div class="image-container" :class="typeCaption">
          <img
            :src="image"
            alt=""
            class="box-image"
            v-if="typeCaption !== 'Lokal' && typeCaption !== 'Fordonsplats'"
          />
          <div class="rental-marker" :class="subtypeCaptionClass">
            {{ subtypeCaption }}
          </div>
        </div>
        <div class="object-text object-text__flex">
          <div class="object-text__column">
            <div class="object-text__inner">
              <div class="object-text__flex">
                <div class="object-text__flex-inner">
                  <h4 class="text-t3">
                    {{ address }}
                    <span v-if="staircase && staircase != 'BV'">, våning {{ staircase }}</span>
                    <span v-if="staircase == 'BV'">{{ staircase }}</span>
                    <!--Sörbygatan 25 -->
                  </h4>
                  <div
                    v-if="flexibleAccess && typeCaption == 'Bostad'"
                    class="object-text__fast-access object-text__fast-access--flexible object-desktop"
                  >
                    Flexibelt tillträde
                  </div>
                </div>
              </div>
              <span class="object-text__neighbourhood" v-if="neighbourhood">
                {{ neighbourhood }}
              </span>
              <span class="object-text__neighbourhood" v-else-if="vatArea">{{ vatArea }}</span>
            </div>
            <div class="object-info">
              <div class="object-info-subcaption" v-if="subCaption">
                <!-- 1 rum och kök -->
                {{ subCaption }}
              </div>
              <div class="area" v-if="quantityBRA && typeCaption != 'Fordonsplats'">
                {{ quantityBRA }} m²
                <!-- 25.5 m2 -->
              </div>
              <div class="area" v-if="parkingNumber">Plats {{ parkingNumber }}</div>
              <div
                class="divider"
                v-if="!parkingNumber && !quantityBRA && subCaption != 'Odlingslott'"
              ></div>
              <div v-if="monthRent">
                {{ addSpace(getPrice(monthRent, vatArea, subCaption, typeCaption)) }}
                kr/månad {{ addAsterisk() }}
                <!-- 2000 kr/månad -->
              </div>
            </div>
          </div>
          <div class="object-text__vacantfrom object-desktop">
            <span>Tillträde: {{ vacantFromText }}</span>
          </div>
        </div>
        <div class="dot"><span class="dot__arrow" /></div>
      </div>
      <div class="object-text__vacantfrom object-mobile">
        <span>Tillträde: {{ vacantFromText }}</span>
        <div
          v-if="flexibleAccess && typeCaption == 'Bostad'"
          class="object-text__fast-access object-text__fast-access--flexible object-mobile"
        >
          Flexibelt tillträde
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/ui/loader';
import RentalObjectMixin from '@/mixins/rentalobject';
import { dataLayerPush } from '@/helpers/datalayer';
import { PARKING_FILTER_TYPES } from '@/config/constants';
import GeneralMixins from '@/mixins/general';
export default {
  mixins: [RentalObjectMixin, GeneralMixins],
  components: { Loader },
  props: {
    isList: {
      type: Boolean,
      required: false,
    },
    rentalObject: {
      type: Object,
      required: false,
    },

    objectCode: {
      type: String,
      required: false,
    },

    unique: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      showLoader: true,
    };
  },

  methods: {
    mtm() {
      dataLayerPush({
        event: 'lasMer',
        objectNumber: this.rentalObjectCode, // objektsnummer t.ex. 9031-008-02-0011 eller 9028-004-02-0012
        objectType: this.typeCaption,
      });
    },

    getPrice(monthRent, vatArea) {
      if (
        PARKING_FILTER_TYPES['CAR'].includes(this.rentalObject.rentalObjectType)
      ) {
        if (this.rentalObject.vatAdded != true) {
          return Math.round(monthRent * 1.25);
        }
      }
      return monthRent;
    },

    addAsterisk() {
      return '';
    },
  },

  computed: {
    ...mapGetters(['authStatus', 'profile']),

    _rentalObject() {
      if (this.rentalObject) {
        return this.rentalObject;
      } else {
        return this.$store.getters.getObjectByObjectCode(this.objectCode);
      }
    },
  },

  created() {
    if (this.objectCode) {
      return this.$store.dispatch('fetchSingleRentalObject', this.objectCode).finally(() => {
        this.showLoader = false;
      });
    } else if (this.rentalObject) {
      this.showLoader = false;
    } else {
      console.log('rentalobjectsearch.vue Varken rentalObject eller objectCode satt :(');

      this.showLoader = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.object {
  cursor: auto !important;
  min-height: calc(100% - 30px);
  margin-bottom: 14px;
  background-color: $backgroundcolorwhite;


  &.Fordonsplats, &.Lokal, &.Odlingslott {

    .object-info {
      margin-top: 10px;
      align-items: center;

      > div {
        margin-bottom: 5px;
      }
    }

    .object-info-subcaption {
      padding: 6px 6px;
      font-size: 12px;
      color: $textcolorgray;
      border-radius: 2px;
      overflow: hidden;
      border: 1px solid $lightgray;
      font-weight: 500;
      margin-right: 3px;
      font-family: $headingfont;

      @media (min-width: 400px) {
        font-size: 14px;
      }
    }
  }
}

.vacancy-module .image-container, .image-container {
  width: 135px;
  height: 135px;
  overflow: hidden;

  @media (min-width: 800px) {
    width: 282px;
    height: 159px;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

.object-text__neighbourhood {
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.64px;
  text-transform: uppercase;

  @media (min-width: 800px) {
    font-size: 16px;
  }
}

.object-text__vacantfrom {
  text-align: right;
  background-color: $lightgray;
  padding: 12px 8px;

  @media (min-width: 1200px) {
    white-space: nowrap;
    background-color: transparent;
    padding: 0;
  }

  &.object-mobile {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    span {
      font-size: 12px;
    }

    .object-text__fast-access {
      margin-top: 0;
    }

    @media (min-width: 1200px) {
      display: none;
    }
  }

  span {
    text-transform: uppercase;
    font-size: 14px;
    padding-left: 8px;
  }
}



.dot {
  transition: all 0.3s;
  opacity: 0;
  height: 154px;
  width: 154px;
  background-color: $abglightblue;
  border-radius: 50%;
  position: absolute;
  bottom: -77px;
  right: -77px;

  .dot__arrow {
    transition: all 0.4s ease-in-out;
    display: block;
    background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-arrow.svg);
    width: 24px;
    height: 24px;
    margin-left: 20px;
    opacity: 0;
    margin-top: 36px;
  }
}

a.object-btn {
  text-decoration: none !important;
  color: $textcolorblack;
}

a:hover {
  @media (min-width: 768px) {
    .object-list-item {
      box-shadow: 0 0 24px 0 rgba(0, 84, 102, 0.12);
    }

    .dot {
      opacity: 1;
      bottom: -77px;
      right: -77px;
    }

    .dot__arrow {
      margin-left: 37px;
      opacity: 1;
    }
  }
}


.object-text {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% - 135px); //100% - image width
  padding: 12px 14px;
  max-height: 135px;

  @media (min-width: 800px) {
    max-height: none;
  }

  .Lokal &, .Fordonsplats &{
    width: 100%;
  }

  @media (min-width: 800px) {
    padding: 24px 32px 25px 30px;
    width: calc(100% - 282px); //100% - image width
  }

  @media (min-width: 1200px) {
    flex-direction: row;
    justify-content: space-between;
  }

  h4, h4 span {
    font-size: 16px;
    font-weight: bold;

    @media (min-width: 800px) {
      font-size: 20px;
    }
  }

  .object-text__inner {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    width: 100%;
  }

  .object-text__flex {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .object-text__column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .object-text__flex-inner {
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.object-text__fast-access {
  border-radius: 2px;
  background-color: $abgyellow;
  padding: 1px 4px 2px 5px;
  white-space: nowrap;

  font-size: 12px;
  text-transform: uppercase;
  line-height: 16px;
  letter-spacing: 0.36px;
  font-weight: bold;

  display: inline-block;
  margin-left: 12px;
  margin-top: 5px;

  &--flexible {
    background-color: #96c11f;
  }
}

.object-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > div {
    color: #333;
    font-size: 12px;
    letter-spacing: 0.08px;
    font-weight: bold;
    font-family: $headingfont;

    @media (min-width: 400px) {
      font-size: 14px;
    }

    @media (min-width: 800px) {
      font-size: 16px;
    }
  }

  .area {
    margin-left: 8px;
    padding-left: 8px;
    border-left: 1px solid $gray;
    font-weight: normal;
    border-right: 1px solid $gray;
    margin-right: 8px;
    padding-right: 8px;
  }

  .divider {
    margin-right: 8px;
    padding-right: 8px;
    border-right: 1px solid $gray;
    font-weight: normal;
  }
}

.object-list-item {
  display: flex;
  flex-direction: row;
  border: 1px solid $lightgray;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.image-container {
  position: relative;
  padding-top: 0;
  margin-bottom: 0;

  &.Fordonsplats, &.Lokal {
    background-color: #eee;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 50%;

    img {
      display: none;
    }
  }

  &.Fordonsplats,  &.Lokal  {
    display: none;
  }

  .rental-marker {
    position: absolute;
    bottom: 8px;
    left: 8px;
    top: initial;
    padding: 6px 6px;
    font-size: 14px;
    color: $textcolorgray;
    border-radius: 2px;
    border: 1px solid $lightgray;
    background-color: $backgroundcolorwhite !important;
    max-width: 88%;

    @media (min-width: 800px) {
      padding: 6px 12px;
      left: 10px;
    }
  }
}

.object-desktop {
  display: none;
  @media (min-width: 1200px) {
    display: block;
  }
}

.object-mobile {
  display: block;
  @media (min-width: 1200px) {
    display: none;
  }
}

</style>
